module.exports = "/_next/static/images/profile-hda-d421d263f46920b8320793d0d30fec1e.png";